(() => {
  const page = document.querySelector('[data-bitig-policy]');
  if (!page || page.dataset.policyReady) return;
  const copy = page.querySelector('[data-policy-copy]');
  const nav = page.querySelector('[data-policy-toc]');
  if (!copy || !nav) return;
  const headings = [...copy.querySelectorAll('h2')];
  if (!headings.length) return;
  const list = nav.querySelector('ol');
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `bitig-policy-section-${index + 1}`;
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    item.append(link);
    list.append(item);
  });
  nav.hidden = false;
  page.dataset.policyReady = 'true';
})();
